module.exports = __webpack_public_path__ + "img/ecommpay.496199a4.svg";